<template>

    <div class="board-view-section ml-xl-4 mr-xl-1 pt-3 pb-1" data-aos="fade-up">

        <draggable tag="div" class="presentation-elements-wrapper" :list="presentations" v-bind="presentationsDragOptions" @change="elementsOrderChange">

            <div class="presentation-element" v-for="presentation in presentations" :key="presentation.identifier" :class="{'checked': selectedPresentations.includes(presentation.identifier)}">

                <div class="image" :style="presentation.icon_url ? {'background-image': 'url(' + presentation.icon_url + ')'} : {'background': '#000000'}"></div>
                <div class="checkbox">
                    <label>
                        <input type="checkbox" v-model="selectedPresentations" :value="presentation.identifier">
                        <span class="checkmark"></span>
                    </label>
                </div>
                <div class="processing-badge" v-if="hasProcessingVideos(presentation)">{{ t.__('Przetwarzanie') }} {{ getProcessingVideosProgress(presentation) }}%</div>
                <div class="error-badge" v-if="hasErrorVideos(presentation)">{{ t.__('Błąd przetwarzania') }}</div>
                <div class="bottom-bar">
                    <div class="handler presentation-handler" :class="{'hidden': selectedSortType !== 'order'}"></div>
                    <div class="name">{{ presentation.name }}</div>
                    <div class="edit-btn" @click="editPresentation(presentation)"></div>
                </div>

            </div>

            <div class="add-presentation-btn" @click="addPresentation">
                <div class="icon"></div>
            </div>

        </draggable>

    </div>

</template>

<script>

import draggable from 'vuedraggable'

export default {

    name: 'PresentationPackageBoardView',

    components: {
        draggable
    },

    props: {
        presentations: Array,
        selectedSortType: String
    },

    data() {
        return {
            eventHub: window.eventHub,
            selectedPresentations: [],
            presentationsDragOptions: {
                animation: 200,
                group: 'presentations',
                disabled: false,
                ghostClass: 'ghost',
                handle: '.presentation-handler',
                draggable: '.presentation-element',
                dragoverBubble: true
            }
        };
    },

    computed: {
        hasProcessingVideos() {
            return presentation => {
                let hasProcessingVideos = false;
                presentation.slides.some(slide => {
                    if (slide.processing === 1) {
                        hasProcessingVideos = true;
                    }
                    return hasProcessingVideos;
                });
                return hasProcessingVideos;
            }
        },
        getProcessingVideosProgress() {
            return presentation => {
                let processingVideosCount = 0;
                let processingVideosPercentageSum = 0;
                presentation.slides.some(slide => {
                    if (slide.processing === 1) {
                        processingVideosCount++;
                        processingVideosPercentageSum = processingVideosPercentageSum + slide.progress;
                    }
                });
                return Math.round(processingVideosPercentageSum / processingVideosCount);
            }
        },
        hasErrorVideos() {
            return presentation => {
                let hasErrorVideos = false;
                presentation.slides.some(slide => {
                    if (slide.processing === 2) {
                        hasErrorVideos = true;
                    }
                    return hasErrorVideos;
                });
                return hasErrorVideos;
            }
        }
    },

    watch: {
        selectedPresentations(newValue, oldValue) {
            this.eventHub.$emit('presentation-package-sync-selected', this.selectedPresentations);
        },
    },

    beforeMount() {

    },

    mounted() {

    },

    methods: {

        addPresentation() {
            this.eventHub.$emit('presentation-package-add-presentation');
        },

        editPresentation(presentation) {
            this.eventHub.$emit('presentation-package-edit-presentation', presentation);
        },

        elementsOrderChange() {
            this.eventHub.$emit('presentation-package-order-changed', this.presentations);
        }

    }

}
</script>

<style scoped>
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
</style>
